// import './assets/style.css';
import './scss/main.scss';

import { initPeriodSelector } from './components/PeriodSelector';
import { initEventForm } from './components/EventForm';
// Mise à jour du chemin pour pointer vers le nouveau fichier index.js
import { initEventList } from './components/EventList/index';
import { initDataManager } from './components/DataManager';
import { initDB } from './services/dbService';
// Importer le module de gestion de la modale d'aide
import { initHelpModal } from './components/HelpModal.js';
import { initColorManager, showColorsModal } from './components/ColorManager';
import {
  loadCustomColors,
  applyCustomColors
} from './services/colorService';
import {
  isSalairesEnabled,
  setSalairesEnabled,
  isHighlightEffectsEnabled,
  setHighlightEffectsEnabled
} from './services/prefsService';
import {
  diagnoseGoogleSetup,
  restoreGoogleAuth,
  initializeGoogleAPI
} from './services/googleDriveService';
import { initCreateEventModal } from './components/CreateEventModal.js';
import { initNotesModal } from './components/NotesModal.js';
// NOUVEAU : Importer le gestionnaire de modales
import {
  initGlobalEscapeHandler,
  exposeGlobalModalFunctions
} from './components/utils/ModalManager.js';

// Permet de faire un diagnostic de la communication avec les services Google
// Taper diagnoseGoogleSetup() dans la console du navigateur
if (typeof window !== 'undefined') {
  window.diagnoseGoogleSetup = diagnoseGoogleSetup;
}

// REMPLACER les anciennes fonctions par l'import du ModalManager
// Les fonctions closeModal, openModalWithEscape sont maintenant dans ModalManager.js

// Fonction pour afficher/masquer les éléments salaires
async function toggleSalairesDisplay(enabled) {
  const body = document.body;

  if (enabled) {
    body.classList.add('salaires-enabled');
  } else {
    body.classList.remove('salaires-enabled');
  }

  console.log('Salaires:', enabled ? 'activés' : 'désactivés');
}

// Fonction pour activer/désactiver les effets visuels
async function toggleHighlightEffects(enabled) {
  const body = document.body;

  if (enabled) {
    body.classList.remove('no-highlight-effects');
  } else {
    body.classList.add('no-highlight-effects');
  }

  console.log('Effets visuels:', enabled ? 'activés' : 'désactivés');
}

// NOUVEAU: Charger les informations de version depuis le fichier
async function loadVersionInfo() {
  try {
    // ✅ CORRIGER : Utiliser le bon nom de fichier
    const response = await fetch('/--version.json'); // ← Supprimer "dev"
    if (response.ok) {
      const versionInfo = await response.json();

      // Mettre à jour la variable globale avec les infos du fichier
      window.APP_BUILD_INFO = {
        ...window.APP_BUILD_INFO,
        ...versionInfo,
        loadedFromFile: true
      };

      return versionInfo;
    }
  } catch (error) {
    console.warn('⚠️ Impossible de charger --version.json:', error);
  }

  // Fallback vers les variables définies à la compilation
  return {
    devFolderName: __DEV_FOLDER_NAME__,
    buildTimestamp: __BUILD_TIMESTAMP__,
    environment: window.location.hostname === 'localhost' ? 'development' : 'production',
    loadedFromFile: false
  };
}

// SEUL EVENT LISTENER DOMContentLoaded - FUSIONNÉ
document.addEventListener('DOMContentLoaded', async function() {
  try {
    console.log("🚀 Initialisation de l'application...");

    // ✨ AJOUTER la classe de chargement au début
    // document.body.classList.add('app-loading');

    // NOUVEAU : Initialiser le gestionnaire de modales en premier
    initGlobalEscapeHandler();
    exposeGlobalModalFunctions();

    // Charger les informations de version
    await loadVersionInfo();

    await initDB();

    // PARALLÉLISER les opérations critiques pour l'affichage
    const [customColors, salairesEnabled, highlightEffectsEnabled] = await Promise.all([
      loadCustomColors(),
      isSalairesEnabled(),
      isHighlightEffectsEnabled()
    ]);

    // Appliquer immédiatement les styles critiques
    applyCustomColors(customColors);
    await Promise.all([
      toggleSalairesDisplay(salairesEnabled),
      toggleHighlightEffects(highlightEffectsEnabled)
    ]);

    // PRIORITÉ 1 : Éléments UI critiques (affichage rapide)
    initColorManager();

    console.log("Initialisation du sélecteur de périodes...");
    await initPeriodSelector();
    console.log("Sélecteur de périodes initialisé !");

    initEventForm();

    // Charger et afficher la liste des événements (élément principal)
    await initEventList();

    console.log("✅ Interface principale chargée !");

    // ✨ TRANSITION FINALE - Révéler l'application
    // document.body.classList.remove('app-loading');

    // PRIORITÉ 2 : Modales (en arrière-plan, non bloquant)
    setTimeout(() => {
      Promise.all([
        initHelpModal(),
        initDataManager(),
        initCreateEventModal(),
        initNotesModal()
      ]).then(() => {
        console.log("✅ Modales initialisées");
      });

      // Initialiser les préférences modal (pas critique)
      initPreferencesModal(salairesEnabled, highlightEffectsEnabled);
    }, 0);

    // PRIORITÉ 3 : Google API (le plus tard possible)
    setTimeout(async () => {
      try {
        await initializeGoogleAPI();
        const googleRestored = await restoreGoogleAuth();
        if (googleRestored) {
          console.log('✅ Connexion Google restaurée automatiquement');
        }
      } catch (error) {
        console.log('ℹ️ Impossible de restaurer la connexion Google:', error.message);
      }
    }, 1000);

    console.log("✅ Application initialisée avec succès !");

  } catch (error) {
    console.error("❌ Erreur lors de l'initialisation:", error);

    // ✨ En cas d'erreur, révéler quand même l'app
    // document.body.classList.remove('app-loading');
  }
});

// Fonction pour initialiser la modal des préférences (extraite)
function initPreferencesModal(salairesEnabled, highlightEffectsEnabled) {
  const prefsBtn = document.getElementById('prefs-btn');
  const prefsModal = document.getElementById('prefs-modal');
  const closePrefsModal = document.getElementById('close-prefs-modal');
  const openColorsModalBtn = document.getElementById('open-colors-modal');
  const enableSalairesCheckbox = document.getElementById('enable-salaires');
  const enableHighlightEffectsCheckbox = document.getElementById('enable-highlight-effects');

  if (!prefsBtn || !prefsModal || !closePrefsModal) return;

  // Pré-remplir avec les valeurs déjà chargées (évite des appels async)
  if (enableSalairesCheckbox) {
    enableSalairesCheckbox.checked = salairesEnabled;
  }
  if (enableHighlightEffectsCheckbox) {
    enableHighlightEffectsCheckbox.checked = highlightEffectsEnabled;
  }

  prefsBtn.addEventListener('click', () => {
    prefsModal.style.display = 'flex';
  });

  closePrefsModal.addEventListener('click', () => {
    prefsModal.style.display = 'none';
  });

  prefsModal.addEventListener('click', (e) => {
    if (e.target === prefsModal) prefsModal.style.display = 'none';
  });

  if (enableSalairesCheckbox) {
    enableSalairesCheckbox.addEventListener('change', async () => {
      await setSalairesEnabled(enableSalairesCheckbox.checked);
      await toggleSalairesDisplay(enableSalairesCheckbox.checked);
    });
  }

  if (enableHighlightEffectsCheckbox) {
    enableHighlightEffectsCheckbox.addEventListener('change', async () => {
      await setHighlightEffectsEnabled(enableHighlightEffectsCheckbox.checked);
      await toggleHighlightEffects(enableHighlightEffectsCheckbox.checked); // ✅ CORRIGER : utiliser la checkbox
    });
  }

  if (openColorsModalBtn) {
    openColorsModalBtn.addEventListener('click', () => {
      prefsModal.style.display = 'none';
      showColorsModal();
    });
  }
}

// Stocker les infos dans une variable globale accessible
window.APP_BUILD_INFO = {
  devFolderName: __DEV_FOLDER_NAME__,
  buildTimestamp: __BUILD_TIMESTAMP__,
  environment: window.location.hostname === 'localhost' ? 'development' : 'production'
};